import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';

export const routes: Route[] = [
  {
    path: '',
    redirectTo: 'candidates',
    pathMatch: 'full',
  },
  {
    path: 'exams',
    loadChildren: () =>
      import('./modules/exam-details/exam-details.module').then(
        (m) => m.ExamDetailsModule
      ),
  },
  {
    path: 'questionnaires',
    loadChildren: () =>
      import('./modules/assessments/assessments.module').then(
        (m) => m.AssessmentsModule
      ),
  },
  {
    path: 'groups',
    loadChildren: () =>
      import('./modules/groups/groups.module').then((m) => m.GroupsModule),
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./modules/profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'stats',
    loadChildren: () =>
      import('./modules/stats/stats.module').then((m) => m.StatsModule),
  },
  {
    path: 'groupStats',
    loadChildren: () =>
      import('./modules/stats-group/stats-group.module').then(
        (m) => m.StatsGroupModule
      ),
  },
  {
    path: 'study-sheets',
    loadChildren: () =>
      import('./modules/study-sheets/study-sheets.module').then(
        (m) => m.StudySheetsModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
